// extracted by mini-css-extract-plugin
export default {"container":"EpisodeCardSkeleton_container__exyEh","title":"EpisodeCardSkeleton_title__r8OJd","date":"EpisodeCardSkeleton_date__bu7dO"};